import { ReactElement } from 'react'
import { BusinessInformation } from '../steps/BusinessInformation'
import { ContactData } from '../steps/ContactData'
import { PaymentMethod } from '../steps/PaymentMethod'
import { SignPoa } from '../steps/SignPoa'
import { Company } from '@/types/company'
import { isGenericCompanyDetails } from '@/modules/company/utils/isGenericCompanyDetails'
import { UserProfile } from '@/types/user-profile'
import { PaymentInfo } from '@/api/payments'

interface MakeStepsProps {
  company: Company
  companyId: string
  user: UserProfile
  paymentMethods: PaymentInfo[]
  companyAddressId: number
}

export const makeSteps = ({
  company,
  companyId,
  companyAddressId,
  user,
  paymentMethods,
}: MakeStepsProps): ReactElement[] => {
  const steps = []
  const hasGenericDetails = isGenericCompanyDetails(
    company.name,
    company.address,
  )

  if (hasGenericDetails) {
    steps.push(
      <BusinessInformation
        companyId={companyId}
        companyAddressId={companyAddressId}
      />,
    )
  }

  if (!user.name || !user.surname) {
    steps.push(<ContactData />)
  }

  if (paymentMethods.length === 0) {
    steps.push(<PaymentMethod companyId={companyId} />)
  }

  if (!company.poaSigned) {
    steps.push(<SignPoa companyId={companyId} />)
  }

  return steps
}
